
export const getVideos = (key = '', attributes, setLoading, nextPageToken, setNextPageToken, setVideos, videos, setError) => {
    const { configure } = attributes;
    const { id, perPage, orderBy, resource } = configure;
    const isChannel = 'channel' === resource;
    const apiUrl = isChannel ? 'search' : 'playlistItems';
    const idParam = isChannel ? { channelId: id } : { playlistId: id };

    gapi.load('client', () => {
        setLoading(true);
        gapi.client
            .init({
                apiKey: key,
                discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/youtube/v3/rest'],
            })
            .then(() => {
                gapi.client.youtube[apiUrl]
                    .list({
                        part: 'snippet',
                        maxResults: perPage,
                        order: orderBy,
                        pageToken: nextPageToken,
                        ...idParam,
                    })
                    .then(
                        (response) => {
                            const { items, nextPageToken } = response?.result || {};
                            setNextPageToken(nextPageToken);

                            const videoIds = items?.map((video) =>
                                isChannel ? video?.id?.videoId : video?.snippet?.resourceId?.videoId
                            );

                            // Fetch videos info
                            fetch(`https://www.googleapis.com/youtube/v3/videos?part=statistics&id=${videoIds.join(",")}&key=${key}`)
                                .then((res) => res.json())
                                .then((data) => {
                                    const newData = items.map((item1) => {
                                        const videoId = isChannel ? item1?.id?.videoId : item1?.snippet?.resourceId?.videoId;
                                        const item2 = data?.items?.find((item) => item?.id === videoId);
                                        return Object.assign({}, item1, item2);
                                    });
                                    setVideos([...videos, ...newData]);
                                    setError(null);
                                })
                                .catch((err) => {
                                    setVideos([])
                                    console.error('Error fetching videos1');
                                    setError(err); // Set the error state for error handling in the UI
                                })
                                .finally(() => {
                                    setLoading(false);
                                });
                        },
                        (err) => {
                            setVideos([]);
                            console.error('Error fetching videos2');
                            setLoading(false);
                            setError(err.result.error.message); // Set the error state for error handling in the UI
                        }
                    )
                    .catch((error) => {
                        setVideos([]);
                        console.error('Error initializing YouTube client3');
                        setLoading(false);
                        setError(error);
                    });
            }).catch((error) => {
                setVideos([]);
                // console.log("Error");
                setLoading(false);
                setError(error.error.message);
            });
    });
};

export const debounce = (cb, delay = 1000) => {
    let timer;

    return (...args) => {
        timer && clearTimeout(timer);

        timer = setTimeout(() => cb(...args), delay);
    }
}


// Layout check
const defaultLayout = {
    info: {
        isView: true, isLike: true, isComment: true, numberSize: 13, numberColor: "#000", iconSize: 15, iconColor: "#000"
    }
}

export const checkLayout = (val) => {

    if (val === 'default') {
        return {
            ...defaultLayout,
            title: { show: true, limit: 50, isLink: true, target: true },
            desc: { show: false, limit: 100 },
            info: { show: false, isView: true, isLike: false, isComment: false, isPDate: true, numberSize: 13, numberColor: "#000", iconSize: 15, iconColor: "#000" }
        }
    }

    if (val === 'grid-details') {
        return {
            ...defaultLayout,
            title: { show: true, limit: 50, isLink: true, target: true },
            desc: { show: true, limit: 100 },
            info: { show: true, isView: true, isLike: true, isComment: true, isPDate: false, numberSize: 13, numberColor: "#000", iconSize: 15, iconColor: "#000" }
        };
    }

    if (val === 'playlist') {
        return {
            ...defaultLayout,
            title: { show: true, limit: 50, isLink: true, target: true },
            desc: { show: true, limit: 100 },
            info: { show: false, isView: true, isLike: true, isComment: true, isPDate: false, numberSize: 13, numberColor: "#000", iconSize: 15, iconColor: "#000" }
        }
    }
}